import { lazy } from 'react';
import Logout from './pages/Logout';
import Login from './pages/Login';
import Gsyjb from './pages/wlb/Gsyjb';
import Yhzhgl from './pages/sys/Yhzhgl';
import CustomerInfoPage from './pages/customer/CustomerInfo';
import AdminList1 from './pages/AdminList1';
import CertificateList from './pages/zxgl/CertificateList';
import TemplateManager from './pages/zxgl/TemplateManager';
import AccountManagement from './pages/zxgl/AccountManagement';
import AppConfig from './pages/sys/AppConfig';
import ZlkManager from './pages/zxgl/Zlk';
import Khxxsp from './pages/spzx/Khxxsp';
import Tbsc from './pages/customer/Tbsc';
import Tbsh from './pages/spzx/Tbsh';
import ComsList from './pages/sys/ComsList';
import ReceiptForm from './pages/cwb/ReceiptForm';
import ReceiptList from './pages/cwb/ReceiptList';
import Lksh from './pages/spzx/Lksh';
import ExpenditureList from './pages/cwb/ExpenditureList';
import Cksh from './pages/spzx/Cksh';
import SzList from './pages/cwb/SzList';
import InvoiceList from './pages/cwb/InvoiceList';
import Xxpsh from './pages/spzx/Xxpsh';
import Pjlist from './pages/cwb/PjList';
import ZxPtba from './pages/zxgl/Ptba';
import HrResource from './pages/zxgl/HrResource';
import TjJxp from './pages/tjb/TjJxp';
import CheckData from './pages/sys/CheckData';
import DBBackupPage from './pages/sys/Dbsys';
import Tjxxp from './pages/tjb/Tjxxp';
import TszList from './pages/list/TszList';
import WeldingList from './pages/list/WeldingList';
import InstallationList from './pages/list/InstallationList';
import CustRoles from './pages/customer/CustRoles';
import EquipmentArchives from './pages/list/EquipmentArchives';
import Hggys from './pages/tjb/Hggys';
import Tjgdzc from './pages/tjb/Tjgdzc';

// 懒加载页面组件
const Home = lazy(() => import('./pages/Home'));
const AdminList = lazy(()=> import('./pages/AdminList'));
const Account = lazy(()=>import('./pages/Account'));
const Cktylist = lazy(()=>import('./pages/KxSmList'));
const Cwtzlist = lazy(()=>import('./pages/cwb/Tzgl'));
const Tblist = lazy(()=>import('./pages/wlb/Tblist'));
const Tbtj = lazy(()=>import('./pages/wlb/Tbtj'));
const Kbts = lazy(()=>import('./pages/wlb/Kbts'));
const Bspd = lazy(()=>import('./pages/wlb/Bspd'));
const Zbxmb = lazy(()=>import('./pages/wlb/Zbxmb'));
const Bcazlk = lazy(()=>import('./pages/wlb/Bcazlk'));
const Zjxmjl = lazy(()=>import('./pages/wlb/Zjxmjl'));
const HtEditor = lazy(()=>import('./pages/cwb/HtEditor'));
const Htlist = lazy(()=>import('./pages/cwb/Htlist'));
const HtAlert1 = lazy(()=>import('./pages/cwb/HtAlert1'));
const HtAlert2 = lazy(()=>import('./pages/cwb/HtAlert2'));
const Htcx = lazy(()=>import('./pages/cwb/Htcx'));
const Tjcenter = lazy(()=>import('./pages/tjb/Tjcenter'));
const Khzllist = lazy(()=>import('./pages/tjb/KhzlList'));
const Myht = lazy(()=>import('./pages/ywb/Myht'));
// 路由配置
export const routes = [
  { path: '/', element: <Home /> },
  { path: '/login', element: <Login /> },
  { path: '/logout', element: <Logout /> },
  { path: '/account', element: <Account /> },
  { path: '/adls', element: <AdminList /> },
  { path: '/lkckkm', element: <Cktylist /> },
  { path: '/tzgl', element: <Cwtzlist /> },
  { path: '/tblist', element: <Tblist /> },
  { path: '/tbtj', element: <Tbtj /> },
  { path: '/tbkbts', element: <Kbts /> },
  { path: '/bspd', element: <Bspd /> },
  { path: '/zjxmjl', element: <Zjxmjl /> },
  { path: '/zbxmb', element: <Zbxmb /> },
  { path: '/gsyjb', element: <Gsyjb /> },
  { path: '/bcamx', element: <Bcazlk /> },
  { path: '/nht', element: <HtEditor /> },
  { path: '/htlist', element: <Htlist /> },
  { path: '/oal1', element: <HtAlert1 /> },
  { path: '/oal2', element: <HtAlert2 /> },
  { path: '/htcx/:sn', element: <Htcx /> },
  { path: '/fskjz', element: <SzList /> },
  { path: '/tjcenter', element: <Tjcenter /> },
  { path: '/khzl', element: <Khzllist /> },
  { path: '/mht', element: <Myht /> },
  { path: '/yhzhgl', element: <Yhzhgl /> },

  { path: '/khgl', element: <CustomerInfoPage /> },
  { path: '/khgl2', element: <CustomerInfoPage /> },
  { path: '/adls1', element: <AdminList1 /> },
  { path: '/adrols', element: <CustRoles /> },
  { path: '/qyzs/:type', element: <CertificateList /> },
  { path: '/wlzh/:type', element: <AccountManagement /> },
  { path: '/mbgl/:type', element: <TemplateManager /> },
  { path: '/zlk/:type', element: <ZlkManager /> },
  { path: '/conf', element: <AppConfig /> },
  { path: '/ptba', element: <ZxPtba /> },
  { path: '/rlzy', element: <HrResource /> },

  { path: '/tbsc', element: <Tbsc /> },
  { path: '/tbsh/:type', element: <Tbsh /> },
  { path: '/khglsh/:type', element: <Khxxsp /> },
  { path: '/reclsh', element: <Lksh /> },
  { path: '/explsh', element: <Cksh /> },
  { path: '/xxpsh', element: <Xxpsh /> },

  { path: '/comsmu', element: <ComsList /> },
  { path: '/recf', element: <ReceiptForm /> },
  { path: '/recl', element: <ReceiptList /> },
  { path: '/zfl', element: <ExpenditureList /> },
  { path: '/invlst', element: <InvoiceList /> },
  { path: '/ckpz', element: <Pjlist /> },

  { path: '/tjjxp', element: <TjJxp /> },
  { path: '/tjxxp', element: <Tjxxp /> },
  { path: '/fcmx', element: <CheckData /> },
  { path: '/db', element: <DBBackupPage /> },
  { path: '/hggys', element: <Hggys /> },
  { path: '/gdzc', element: <Tjgdzc /> },

  { path: '/tsz/:type', element: <TszList /> },
  { path: '/hjgy', element: <WeldingList /> },
  { path: '/azyj', element: <InstallationList /> },
  { path: '/ea/:type', element: <EquipmentArchives /> },

];